import { PropsWithChildren, useRef } from "react";
import { useDrag, useDrop } from "react-dnd";

export interface DraggableRowProps {
  index: number;
  moveRow: (dragIndex: number, hoverIndex: number) => void;
  onDropComplete: (dragIndex?: number, hoverIndex?: number) => void;
  custumClassName?: string;
}

const DraggableRow: React.FC<PropsWithChildren<DraggableRowProps>> = ({
  children,
  index,
  moveRow,
  onDropComplete,
  custumClassName 
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const [, drag] = useDrag({
    type: "ROW",
    item: { index },
  });

  const [, drop] = useDrop({
    accept: "ROW",
    hover: (item: { index: number }, monitor) => {
      if (!ref.current) return;
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) return;
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY =
        (clientOffset as { y: number }).y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;
      moveRow(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
    drop: (item: { index: number }) => {
      onDropComplete?.();
    },
  });

  drag(drop(ref));

  return (
    <div
      ref={ref}
      style={{ cursor: "grab" }}
      className={`${custumClassName || "w-full h-full cursor-grab flex items-center"}`}
    >
      {children}
    </div>
  );
};

export default DraggableRow;
